export const ProgramSteps={
  MAIN: 'Main',
  ERROR_WITH_TOKEN:'ErrorWithToken',
  OPPORTUNITY_ID_NOT_FOUND: 'OpportunityIdNotFound',
  BLACK_LIST_VALIDATION_GENERAL_ERROR: 'BlackListValidationGeneralError',
  JET_UPDATE_GENERAL_ERROR: 'JetUpdateGeneralError',
  SUCCESS_PAGE: 'SuccessPage',
}

export const ProcessRelevantRoles = ["SILENTOTP_JET_CREDITCARDINFO"];
